module.exports = __webpack_public_path__ + "img/btn-swiper-prev-02.dafe3c8d.svg";